<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    @close="$router.replace('/lists')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="glaNumber"
      :rules="rules"
      ref="glaNumberForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="value"
        label="Érték"
        :error="errors.value ? errors.value[0] : null"
      >
        <el-input v-model="glaNumber.value" />
      </el-form-item>
      <el-form-item
        prop="description"
        label="Megnevezés"
      >
        <el-input v-model="glaNumber.description" type="textarea" />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/lists')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'glaNumberId'],
    data() {
      const checkValue = (rule, value, callback) => {
        if (isNaN(parseFloat(value)) || (typeof value === 'string' && !value.match(/^\d*\.?\d*?$/))) {
          return callback(new Error('Ez a mező csak számokat tartalmazhat'));
        }
        return callback();
      };
      return {
        loading: false,
        buttonLoading: false,
        errors: {
          value: null,
        },
        glaNumber: {},
        rules: {
          value :[
            { required: true, message: 'Mező megadása kötelező', trigger: 'blur' },
            { validator: checkValue, trigger: 'change'}
          ]
        }
      }
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Főkönyvi szám';
        } else if (this.type === 'update') {
          return 'Főkönyvi szám módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    methods: {
      async add() {
        this.$refs['glaNumberForm'].validate(async valid => {
          if(valid) {
            this.buttonLoading = true;
            this.errors.value = null;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('glaNumber/add', this.glaNumber);
              } else if (this.type === 'update') {
                await this.$store.dispatch('glaNumber/update', this.glaNumber);
              }
              this.$store.dispatch('glaNumber/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/lists');
            } catch (e) {
              if (e.data && e.data.errors) {
                this.errors = e.data.errors;
              }
            }
            this.buttonLoading = false;
          }
        });
      }
    },

    async mounted() {
      this.loading = true;
      if(this.glaNumberId) {
        this.glaNumber = await this.$store.dispatch('glaNumber/fetch', this.glaNumberId);
      }
      this.loading = false;
    }
  }
</script>
